// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__dskc7","content":"styles_content__3Gi4r"};